import React, { FC } from 'react';
import { FormField, FormFieldProps } from '../FormField';
import { ButtonToggle } from '../ButtonToggle';

export type FormButtonToggleProps = FormFieldProps;

export const FormButtonToggle: FC<FormButtonToggleProps> = ({ ...props }) => {
	return <FormField control={ButtonToggle} {...props} />;
};
